import React, { useEffect, useState } from 'react';
import { Modal } from './Modal';
import { PenkiChip } from './PenkiBadge';
import { apiClient } from '../services/api';
import type { PenkiRateRow } from '../types';
import './PenkiRateModal.css';

export const PenkiRateEntry: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <button type="button" className="penki-rate-entry" onClick={onClick}>
      <span className="penki-rate-entry-content">
        <span className="penka-icon penka-icon--lg" aria-hidden>
          <img src="/uym-mark.png" alt="" />
        </span>
        <span className="penki-rate-entry-text">
          <span className="penki-rate-entry-title">УЙМЫ за ху#ки</span>
          <span className="penki-rate-entry-subtitle">
            Узнай, сколько УЙМ приносит каждый ху#к
          </span>
        </span>
      </span>
      <img src="/penki-chevron-right.svg" alt="" className="penki-rate-entry-chevron" />
    </button>
  );
};

interface PenkiRateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PenkiRateModal: React.FC<PenkiRateModalProps> = ({ isOpen, onClose }) => {
  const [rows, setRows] = useState<PenkiRateRow[]>([]);

  useEffect(() => {
    if (!isOpen || rows.length > 0) return;
    apiClient
      .getPenkiRates()
      .then(setRows)
      .catch((err) => console.error('Failed to load penki rates:', err));
  }, [isOpen, rows.length]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} containerClassName="penki-rate-modal">
      <div className="penki-rate-header">
        <h2 className="penki-rate-title">УЙМЫ за ху#ки</h2>
        <p className="penki-rate-subtitle">
          Сколько УЙМ тебе прилетит в сутки — зависит от цены ху#ков
        </p>
      </div>

      <div className="penki-rate-grid">
        {rows.map((row) => (
          <div className="penki-rate-cell" key={row.step}>
            <span className="penki-rate-cell-label">Цена</span>
            <div className="penki-rate-cell-row">
              <span className="penki-rate-cell-price">
                {new Intl.NumberFormat('ru-RU').format(row.price_rub)} ₽
              </span>
              <PenkiChip value={row.penki} />
            </div>
          </div>
        ))}
      </div>

      <button type="button" className="button button--primary button--full" onClick={onClose}>
        Понятно
      </button>
    </Modal>
  );
};
